import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "group/navItem"
}
const _hoisted_2 = ["textContent", "href"]
const _hoisted_3 = ["textContent", "href"]
const _hoisted_4 = {
  key: 0,
  class: "relative hidden group-hover/navItem:block cursor-default"
}
const _hoisted_5 = {
  class: /*@__PURE__*/_normalizeClass([
          'absolute left-1/2 -translate-x-1/2 top-2',
          'bg-tile p-2 font-medium space-y-2',
          'border rounded-lg border-tile-border',
        ])
}
const _hoisted_6 = ["textContent", "href", "onClick"]
const _hoisted_7 = {
  key: 2,
  class: "mr-auto"
}

import {computed} from "vue";
import Button from "../../../../DesignSystem/Button.vue";
import {NavigationAction} from "../../../Port/NavigationService";
import {useNavigationStore} from "../../navigationStore";
import {NavigationItem} from "../../Presenter/entryPointItems";
import {useNavigationService} from "../../vue";
import ForumMenu from "../ForumMenuDesktop.vue";

const navigationLinkStyle = 'max-lg:hidden cursor-pointer py-2 px-1 xl:px-3 rounded';

interface Emit {
  (event: 'action', action: NavigationAction): void;
}

interface Props {
  type: 'link'|'buttonSecondary'|'space';
  title?: string;
  forumMenu?: boolean;
  action?: NavigationAction;
  children?: NavigationItem[];
  childrenForNotAuthenticated?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'NavTopbarListItem',
  props: {
    type: {},
    title: {},
    forumMenu: { type: Boolean },
    action: {},
    children: {},
    childrenForNotAuthenticated: { type: Boolean }
  },
  emits: ['click'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const store = useNavigationStore();
const service = useNavigationService();

function action(action: NavigationAction): void {
  emit('action', action);
}

function actionHref(action: NavigationAction): string|null {
  return service.actionHref(action);
}

function click(): void {
  action(props.action);
}

const includeChildren = computed<boolean>(() => {
  if (props.childrenForNotAuthenticated && store.isAuthenticated) {
    return false;
  }
  return props.children?.length > 0;
});

return (_ctx: any,_cache: any) => {
  return (props.type === 'link')
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        (props.forumMenu)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("a", {
                class: _normalizeClass([navigationLinkStyle, "group-hover/navItem:text-green2-500"]),
                textContent: _toDisplayString(props.title),
                onClick: _withModifiers(click, ["prevent"]),
                href: actionHref(props.action)
              }, null, 8 /* PROPS */, _hoisted_2),
              _createVNode(ForumMenu)
            ]))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass([navigationLinkStyle, "whitespace-nowrap group/navItem"])
            }, [
              _createElementVNode("a", {
                class: "block hover:text-green2-500",
                textContent: _toDisplayString(props.title),
                onClick: _withModifiers(click, ["prevent"]),
                href: actionHref(props.action)
              }, null, 8 /* PROPS */, _hoisted_3),
              (includeChildren.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.children, (child) => {
                        return (_openBlock(), _createElementBlock("a", {
                          class: "block hover:text-green2-500 p-2 cursor-pointer",
                          textContent: _toDisplayString(child.title),
                          href: actionHref(child.action),
                          onClick: _withModifiers(($event: any) => (action(child.action)), ["prevent"])
                        }, null, 8 /* PROPS */, _hoisted_6))
                      }), 256 /* UNKEYED_FRAGMENT */))
                    ])
                  ]))
                : _createCommentVNode("v-if", true)
            ]))
      ], 64 /* STABLE_FRAGMENT */))
    : (props.type === 'buttonSecondary')
      ? (_openBlock(), _createBlock(Button, {
          key: 1,
          class: "text-base h-10 leading-6",
          "primary-outline": "",
          title: props.title,
          onClick: click
        }, null, 8 /* PROPS */, ["title"]))
      : (props.type === 'space')
        ? (_openBlock(), _createElementBlock("div", _hoisted_7))
        : _createCommentVNode("v-if", true)
}
}

})